// import React, { useState, useEffect, useRef } from 'react';
// import ChatMessage from '../components/ChatMessage';
// import ChatInput from '../components/ChatInput';
// import { BASE_URL } from '../config';

// const ChatBot = () => {
//   const [messages, setMessages] = useState([]);
//   const [currentStep, setCurrentStep] = useState(null);
//   const [isLoading, setIsLoading] = useState(true);
//   const [isTyping, setIsTyping] = useState(false);
//   const [showHistoryPopup, setShowHistoryPopup] = useState(false);
// const [hasHistory, setHasHistory] = useState(false);

//   const messagesEndRef = useRef(null);

//   useEffect(() => {
//   const checkHistory = async () => {
//     try {
//       const response = await fetch(`${BASE_URL}/api/v1/chat/history`, {
//         credentials: 'include'
//       });
//       const history = await response.json();
//       if (history.length > 0) {
//         setHasHistory(true);
//         // Show popup after initial load
//         setTimeout(() => setShowHistoryPopup(true), 2000);
//       }
//     } catch (err) {
//       console.error('Failed to check history:', err);
//     }
//   };
  
//    if (!isLoading) {
//     checkHistory();
//   }
// }, [isLoading]);

//   // Fetch initial greeting
//   useEffect(() => {
//     const fetchInitialStep = async () => {
//       try {
//         // const response = await fetch('/api/v1/chat/init');
//         const response = await fetch(`${BASE_URL}/api/v1/chat/init`, {
//           credentials: 'include'
//         });
//         const data = await response.json();
//         setCurrentStep(data);
//         // setMessages([{ 
//         //   id: 'welcome', 
//         //   text: data.message, 
//         //   sender: 'bot' 
//         // }]);
//         const splitMessages = data.message.split('\n').filter(Boolean);
// const botMessages = splitMessages.map((line, index) => ({
//   id: `welcome_${Date.now()}_${index}`,
//   text: line,
//   sender: 'bot',
// }));

// setMessages(botMessages);

//       } catch (err) {
//         console.error('Failed to load chat:', err);
//       } finally {
//         setIsLoading(false);
//       }
//     };

//     fetchInitialStep();
//   }, []);

//   // Scroll to bottom of chat
//   useEffect(() => {
//     messagesEndRef.current?.scrollIntoView({ behavior: 'smooth' });
//   }, [messages, isTyping]);

//   // Handle user response
//   const handleUserResponse = async (text, imageData = null) => {
//     // Add user message
//     const userMessage = { id: `user_${Date.now()}`, text:text,imageUrl: imageData?.fullUrl || null, sender: 'user' };
//     setMessages(prev => [...prev, userMessage]);
    
//     try {
//       setIsLoading(true);
//        setIsTyping(true);
      
//       // Get next step from backend
//     //   const res = await fetch('/api/v1/chat/next', 
//           setTimeout(async () => {
//          const res = await fetch(`${BASE_URL}/api/v1/chat/next`,  
//         {
//         method: 'POST',
//         headers: { 'Content-Type': 'application/json' },
//           credentials: 'include',
//         body: JSON.stringify({ 
//           currentStepId: currentStep.stepId,  
//           userInput: text || '',
//         // imageUrl: imageUrl || null,
//         imageUrl: imageData?.fullUrl || null,
//            imagePath: imageData?.rawPath || null
//         })
//       });
      
//       const nextStep = await res.json();
//       setCurrentStep(nextStep);

//        // Add bot response
//     const botMessage = {
//       id: `bot_${Date.now()}`,
//       text: nextStep.message,
//       sender: 'bot'
//     };
    
      
//       // Add bot response
//       // setMessages(prev => [
//       //   ...prev, 
//       //   { id: `bot_${Date.now()}`,   text: nextStep.message, sender: 'bot' }
//       // ]);
//           setMessages(prev => [...prev, botMessage]);
//      setIsTyping(false);
//       }, 1500);
//     } catch (err) {
//       console.error('Error getting next step:', err);
//       setMessages(prev => [
//         ...prev, 
//         { 
//           id: 'error', 
//           text: 'Sorry, something went wrong. Please try again.', 
//           sender: 'bot' 
//         }
//       ]);
//             setIsTyping(false);

//     } finally {
//       setIsLoading(false);
//     }
//   };

//   return (
//     // <div className="flex flex-col h-screen max-w-4xl mx-auto bg-white shadow-lg">
//       <div className="flex flex-col h-screen w-full bg-white md:max-w-[450px] md:mx-auto md:shadow-lg">
//       {/* Chat Header */}
//       <div className="bg-indigo-600 text-white p-4">
//         <h1 className="text-xl font-bold">Customer Support Chat</h1>
//       </div>
      
//       {/* Chat Messages */}
//       <div className="flex-1 overflow-y-auto p-4 bg-gray-50 w-full ">
//         {isLoading && !messages.length ? (
//           <div className="flex justify-center items-center h-full">
//             <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-indigo-500"></div>
//           </div>
//         ) : (
//           <>
//             {messages.map((msg) => (
//               <ChatMessage 
//                 key={msg.id} 
//                 message={msg.text} 
//                 sender={msg.sender} 
//                 imageUrl={msg.imageUrl}
//               />
//             ))}
//               {isTyping && (
//               <div className="flex justify-start mb-4">
//                 <div className="bg-gray-200 text-gray-800 px-4 py-3 min-h-[40px] rounded-lg rounded-bl-none max-w-[80%] md:max-w-xs flex items-center space-x-1 animate-pulse">
//                   <div className="w-2 h-2 bg-blue-600 rounded-full animate-bounce"></div>
//                   <div className="w-2 h-2 bg-blue-600 rounded-full animate-bounce delay-150"></div>
//                   <div className="w-2 h-2 bg-blue-600 rounded-full animate-bounce delay-300"></div>
//                 </div>
//               </div>
//             )}
//             <div ref={messagesEndRef} />
//           </>
//         )}
//       </div>
      
//       {/* Chat Input */}
//       {currentStep && (
//         <ChatInput 
//           options={currentStep.options} 
//           inputType={currentStep.inputType}
//           onSend={handleUserResponse}
//           isLoading={isLoading || isTyping}
//         />
//       )}

//       {/* {showHistoryPopup && hasHistory && (
//   <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
//     <div className="bg-white rounded-xl shadow-2xl max-w-md w-full transform transition-all duration-300 scale-95 animate-scaleIn">
//       <div className="p-6">
//         <h3 className="text-xl font-bold text-gray-800 mb-3">Would you like to view past chats?</h3> */}
//         {/* <p className="text-gray-600 mb-5">
//           We found your previous chat history. Would you like to view it?
//         </p> */}
//         {/* <div className="flex justify-end space-x-3">
//           <button
//             onClick={() => setShowHistoryPopup(false)}
//             className="px-4 py-2 border border-gray-300 rounded-lg text-gray-700 hover:bg-gray-50 transition-colors"
//           >
//             Not Now
//           </button>
//           <button
//             onClick={() => {
//               window.open('/chat-history', '_blank');
//               setShowHistoryPopup(false);
//             }}
//             className="px-4 py-2 bg-indigo-600 text-white rounded-lg hover:bg-indigo-700 transition-colors shadow-md"
//           >
//             View History
//           </button>
//         </div>
//       </div>
//     </div>
//   </div>
// )} */}

// {showHistoryPopup && hasHistory && (
//   <div className="fixed inset-0 bg-black bg-opacity-30 flex items-center justify-center z-50">
//     <div className="bg-white shadow-lg rounded-md px-4 py-3 w-[80%] max-w-[240px] border border-gray-200 animate-fadeIn">
//       <div className="text-sm text-gray-800 font-medium mb-2 text-center">
//         Would you like to view past chats?
//       </div>
//       <div className="flex justify-center gap-3 mt-2">
//         <button
//           onClick={() => setShowHistoryPopup(false)}
//           className="text-xs text-gray-600 hover:text-gray-800 transition"
//         >
//           Not now
//         </button>
//         <button
//           onClick={() => {
//             window.open('/chat-history', '_blank');
//             setShowHistoryPopup(false);
//           }}
//           className="text-xs bg-indigo-600 text-white px-3 py-1 rounded hover:bg-indigo-700 transition"
//         >
//           View
//         </button>
//       </div>
//     </div>
//   </div>
// )}

//     </div>

//   );
// };

// export default ChatBot;




import React, { useState, useEffect, useRef } from 'react';
import ChatMessage from '../components/ChatMessage';
import ChatInput from '../components/ChatInput';
import { BASE_URL } from '../config';

const ChatBot = () => {
  const [messages, setMessages] = useState([]);
  const [currentStep, setCurrentStep] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [isTyping, setIsTyping] = useState(false);
  const [showHistoryPopup, setShowHistoryPopup] = useState(false);
  const [hasHistory, setHasHistory] = useState(false);

  const messagesEndRef = useRef(null);
  const [viewportHeight, setViewportHeight] = useState(window.innerHeight);

  useEffect(() => {
    const handleResize = () => {
      setViewportHeight(window.innerHeight);
    };

    window.addEventListener('resize', handleResize);
    handleResize();

    return () => window.removeEventListener('resize', handleResize);
  }, []);

  useEffect(() => {
    const checkHistory = async () => {
      try {
        const response = await fetch(`${BASE_URL}/api/v1/chat/history`, {
          credentials: 'include',
        });
        const history = await response.json();
        if (history.length > 0) {
          setHasHistory(true);
          setTimeout(() => setShowHistoryPopup(true), 2000);
        }
      } catch (err) {
        console.error('Failed to check history:', err);
      }
    };

    if (!isLoading) {
      checkHistory();
    }
  }, [isLoading]);

  useEffect(() => {
    const fetchInitialStep = async () => {
      try {
        const response = await fetch(`${BASE_URL}/api/v1/chat/init`, {
          credentials: 'include',
        });
        const data = await response.json();
        setCurrentStep(data);
        const splitMessages = data.message.split('\n').filter(Boolean);
        const botMessages = splitMessages.map((line, index) => ({
          id: `welcome_${Date.now()}_${index}`,
          text: line,
          sender: 'bot',
        }));
        setMessages(botMessages);
      } catch (err) {
        console.error('Failed to load chat:', err);
      } finally {
        setIsLoading(false);
      }
    };

    fetchInitialStep();
  }, []);

  useEffect(() => {
    messagesEndRef.current?.scrollIntoView({ behavior: 'smooth' });
  }, [messages, isTyping]);

  const handleUserResponse = async (text, imageData = null) => {
    const userMessage = {
      id: `user_${Date.now()}`,
      text: text,
      imageUrl: imageData?.fullUrl || null,
      sender: 'user',
    };
    setMessages((prev) => [...prev, userMessage]);

    try {
      setIsLoading(true);
      setIsTyping(true);

      setTimeout(async () => {
        const res = await fetch(`${BASE_URL}/api/v1/chat/next`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          credentials: 'include',
          body: JSON.stringify({
            currentStepId: currentStep.stepId,
            userInput: text || '',
            imageUrl: imageData?.fullUrl || null,
            imagePath: imageData?.rawPath || null,
          }),
        });

        const nextStep = await res.json();
        setCurrentStep(nextStep);
        const botMessage = {
          id: `bot_${Date.now()}`,
          text: nextStep.message,
          sender: 'bot',
        };
        setMessages((prev) => [...prev, botMessage]);
        setIsTyping(false);
      }, 1500);
    } catch (err) {
      console.error('Error getting next step:', err);
      setMessages((prev) => [
        ...prev,
        {
          id: 'error',
          text: 'Sorry, something went wrong. Please try again.',
          sender: 'bot',
        },
      ]);
      setIsTyping(false);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div
      style={{
        height: `${viewportHeight}px`,
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        backgroundColor: 'white',
        maxWidth: '450px',
        margin: '0 auto',
        position: 'relative',
      }}
    >
      {/* Header */}
      <div
        style={{
          backgroundColor: '#4f46e5',
          color: 'white',
          padding: '1rem',
          position: 'fixed',
          top: 0,
          width: '100%',
          maxWidth: '450px',
          zIndex: 10,
        }}
      >
        <h1 style={{ fontSize: '1.25rem', fontWeight: 'bold' }}>
          Customer Support Chat
        </h1>
      </div>

      {/* Chat Messages */}
      <div
    
      //          style={{
      //   position: 'fixed',
      //   top: '64px', // header height
      //   bottom: '64px', // input height
      //   left: 0,
      //   right: 0,
      //   overflowY: 'auto',
      //   backgroundColor: '#f9fafb',
      //   padding: '0 1rem',
      // }}

              style={{
          position: window.innerWidth <= 768 ? 'fixed' : 'absolute',
          top: '64px', // header height
          bottom: '64px', // input height
          left: 0,
          right: 0,
          overflowY: 'auto',
          backgroundColor: '#f9fafb',
          padding: '8px 1rem 0',
          // marginTop: window.innerWidth > 768 ? '0.5rem' : '0' // small gap only on desktop
        }}

      >
        {isLoading && !messages.length ? (
          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              height: '100%',
            }}
          >
            <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-indigo-500"></div>
          </div>
        ) : (
          <>
            {messages.map((msg) => (
              <ChatMessage
                key={msg.id}
                message={msg.text}
                sender={msg.sender}
                imageUrl={msg.imageUrl}
              />
            ))}
            {isTyping && (
              <div className="flex justify-start mb-4">
                <div className="bg-gray-200 text-gray-800 px-4 py-3 min-h-[40px] rounded-lg rounded-bl-none max-w-[80%] md:max-w-xs flex items-center space-x-1 animate-pulse">
                  <div className="w-2 h-2 bg-blue-600 rounded-full animate-bounce"></div>
                  <div className="w-2 h-2 bg-blue-600 rounded-full animate-bounce delay-150"></div>
                  <div className="w-2 h-2 bg-blue-600 rounded-full animate-bounce delay-300"></div>
                </div>
              </div>
            )}
            <div ref={messagesEndRef} />
          </>
        )}
      </div>

      {/* Chat Input */}
      <div
        style={{
          position: 'fixed',
          bottom: 0,
          width: '100%',
          maxWidth: '450px',
          backgroundColor: 'white',
          zIndex: 10,
        }}
      >
        {currentStep && (
          <ChatInput
            options={currentStep.options}
            inputType={currentStep.inputType}
            onSend={handleUserResponse}
            isLoading={isLoading || isTyping}
          />
        )}
      </div>

      {/* History Popup */}
      {showHistoryPopup && hasHistory && (
        <div className="fixed inset-0 bg-black bg-opacity-30 flex items-center justify-center z-50">
          <div className="bg-white shadow-lg rounded-md px-4 py-3 w-[80%] max-w-[240px] border border-gray-200 animate-fadeIn">
            <div className="text-sm text-gray-800 font-medium mb-2 text-center">
              Would you like to view past chats?
            </div>
            <div className="flex justify-center gap-3 mt-2">
              <button
                onClick={() => setShowHistoryPopup(false)}
                className="text-xs text-gray-600 hover:text-gray-800 transition"
              >
                Not now
              </button>
              <button
                onClick={() => {
                  window.open('/chat-history', '_blank');
                  setShowHistoryPopup(false);
                }}
                className="text-xs bg-indigo-600 text-white px-3 py-1 rounded hover:bg-indigo-700 transition"
              >
                View
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ChatBot;
